import { render } from "./QualityOfLife2.vue?vue&type=template&id=1b8e01cc&scoped=true"
import script from "./QualityOfLife2.vue?vue&type=script&lang=js"
export * from "./QualityOfLife2.vue?vue&type=script&lang=js"

import "./QualityOfLife2.vue?vue&type=style&index=0&id=1b8e01cc&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8e01cc"]])

export default __exports__